import { action } from 'typesafe-actions';
import { IUpdatePasswordActionTypes } from './Types';

export const updatePasswordFromEmail = (
	newPwd: string,
	token: string,
	id: string
) =>
	action(IUpdatePasswordActionTypes.UPDATE_PASSWORD_FROM_EMAIL, [
		newPwd,
		token,
		id,
	]);
export const updatePasswordFromPrevious = (
	oldPwd: string,
	newPwd: string,
	token: string,
	id: string
) =>
	action(IUpdatePasswordActionTypes.UPDATE_PASSWORD_FROM_PREVIOUS, [
		oldPwd,
		newPwd,
		token,
		id,
	]);
export const updatePasswordSucceed = () =>
	action(IUpdatePasswordActionTypes.UPDATE_PASSWORD_SUCCEED);
export const updatePasswordFailed = (err: string) =>
	action(IUpdatePasswordActionTypes.UPDATE_PASSWORD_FAILED, err);
export const newPasswordValid = () =>
	action(IUpdatePasswordActionTypes.NEW_PASSWORD_IS_VALID);
export const newPasswordInvalid = (err: string) =>
	action(IUpdatePasswordActionTypes.NEW_PASSWORD_IS_INVALID);
